import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useIntl } from "gatsby-plugin-intl";
import { mq, prefix } from "../util";

const imageCSS = { gridColumn: "1", gridRow: ["1", "1 / span 2"], zIndex: -1 };

const Hero = ({ file, src = "", alt = "", title, content, id = "" }) => {
  const { locale } = useIntl();

  return (
    <div
      id={id}
      css={mq({
        display: "grid",
        gridTemplateRows: [400, "auto"],
        rowGap: [null, 20],
        paddingBottom: ["2em", 42],
      })}>
      {file ? (
        <GatsbyImage image={getImage(file)} alt={alt} css={mq(imageCSS)} />
      ) : (
        <img
          src={prefix(src)}
          alt={alt}
          css={mq({
            ...imageCSS,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          })}
        />
      )}
      <h2
        css={mq({
          fontSize: [35, null, 55],
          textAlign: "center",
          gridColumn: "1",
          gridRow: content ? "1" : "1 / span 2",
          alignSelf: ["center", content ? "end" : null],
          letterSpacing: locale !== "en" && "0.29em",
        })}>
        {title}
      </h2>
      {content && (
        <section
          css={mq({
            padding: ["0 35px"],
            lineHeight: 1.5,
            gridColumn: "1",
            gridRow: "2",
            justifySelf: [null, "center"],
            width: [null, 610],
          })}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};

export default Hero;
